import { getTenantDisplayName } from "../utils/common";
import brandingMap from "./tenantBranding.json";

export interface TenantBranding {
  displayName: string;
  welcomeTitle: string;
  welcomeSubtitle: string;
  welcomeTagline: string;
  logoTitle: string;
  headerTitle: string;
  /** Browser tab / document title */
  pageTitle: string;
}

type TenantBrandingMap = Record<string, TenantBranding>;

const branding = brandingMap as TenantBrandingMap;

/**
 * Get branding config for a tenant ID.
 * Uses the tenant name (3rd segment of tenant_id) as key; falls back to "default" if not found.
 */
export function getTenantBranding(tenantId: string): TenantBranding {
  const tenantName = getTenantDisplayName(tenantId);
  const key = tenantName.toLowerCase();
  return branding[key] ?? branding.default;
}
